import React, { createContext, useContext, useEffect } from "react";
import axiosInstance from "./axiosInstance";
import { useAuth } from "./AuthContext";

const AxiosContext = createContext();

export const AxiosProvider = ({ children }) => {
  const AuthToken = localStorage.getItem("AuthUser");

  useEffect(() => {
    if (AuthToken) {
      console.log("THIS IS FROM THE AXIOS CONTEXT", AuthToken);
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${AuthToken}`;
    } else {
      delete axiosInstance.defaults.headers.common["Authorization"];
    }
  }, [AuthToken]);

  return (
    <AxiosContext.Provider value={axiosInstance}>
      {children}
    </AxiosContext.Provider>
  );
};

export const useAxios = () => {
  return useContext(AxiosContext);
};
